// 0: ЖКТ
// 1: Остеопороз
// 2: Кардиология
// 3: Неврология

const coursesOrderBySpec = {
  'Гастроэнтерология': [0, 2, 1],
  'Терапия': [3, 2, 0, 1],
  'Общая врачебная практика (семейная медицина)': [3, 0, 2, 4],
  'Хирургия': [0, 2, 1],
  'Гериатрия': [2, 0, 1],
  'Лечебное дело': [3, 0, 2, 1],
  'Клиническая лабораторная диагностика': [0, 2, 1],
  'Клиническая фармакология': [0, 2],
  'Эндокринология': [1, 2],
  'Акушерство и гинекология:': [2, 1],
  'Кардиология': [2, 1, 0],
  'Гематология': [2, 1, 0],
  'Лечебная физкультура и спортивная медицина': [1, 2],
  'Ревматология': [2, 1],
  'Неврология': [3, 2, 1, 0],
  'Травматология и ортопедия': [1, 2],
  'Нефрология': [2, 1],
  'Психиатрия': [3],
}

export { coursesOrderBySpec }